import { msg } from "@lingui/core/macro";
import { createRoute, useSearch } from "@tanstack/solid-router";
import { useNavigate } from "@/lib/u-router";
import { appRoute } from "./route";
import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";
import { PurchasingManager } from "@/features/purchasing/components/purchasing-manager";
import { RestaurantGate } from "@/features/pos/components/restaurant-gate";
import { useActiveContext } from "@/features/pos/hooks/use-active-context";
import { useI18n } from "@/providers/i18n-provider";

/**
 * Search params de Compras — hacen su estado COMPARTIBLE por URL (campaña #15b,
 * mismo patrón que el POS `?order=`):
 *   - `po`: la orden de compra seleccionada (panel de líneas abierto). Copiar/pegar
 *     la URL reabre ese detalle en otro dispositivo/pestaña; si el id ya no existe
 *     la lista de líneas simplemente queda vacía (sin loader colgado).
 */
interface PurchasingSearch {
  po?: string;
}

function PurchasingPage() {
  const { t } = useI18n();
  const ctx = useActiveContext();
  const search = useSearch({ from: purchasingRoute.id });
  const navigate = useNavigate();
  return (
    <PageContainer maxWidth="5xl">
      <PageHeader title={t(msg`Purchasing`)} />
      <RestaurantGate ctx={ctx}>
        {(c) => (
          <PurchasingManager
            org={c.org}
            branch={c.branch}
            poParam={() => search().po}
            onPoChange={(po) => {
              void navigate({
                to: "/purchasing",
                search: (prev: PurchasingSearch) => ({ ...prev, po: po ?? undefined }),
                replace: true,
              });
            }}
          />
        )}
      </RestaurantGate>
    </PageContainer>
  );
}

export const purchasingRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/purchasing",
  validateSearch: (search: Record<string, unknown>): PurchasingSearch => ({
    po: typeof search.po === "string" && search.po.trim() !== "" ? search.po : undefined,
  }),
  component: PurchasingPage,
});
